import { useTaxActions } from "../actions/taxActions"
import { useTaxBuilders } from "../builders/taxBuilders"
import { useTaxLoaders } from "../loaders/taxLoaders"

export const useTaxService = () => {
    const { buildTax } = useTaxBuilders()
    
    const taxLoaders = useTaxLoaders()
    
    const { saveTax } = useTaxActions()

    const archiveTax = async (taxId: string) => {
        const { loadTax } = taxLoaders()
        const tax = await loadTax(taxId, true)
        const archivedTax = buildTax({
            ...tax,
            archived: true
        })
        return saveTax(archivedTax)
    }

    return {
        archiveTax
    }
}
